import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'calsoft-configure',
  templateUrl: './configure.component.html',
  styleUrls: ['./configure.component.scss']
})
export class ConfigureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  @Input()  showNewConfig:boolean=false;
  @Input() configattributeType: any;
  @Input() firstIndex: any;
  @Input()  secondIndex: any;
  @Input() configurationDropDownList = new Map<any, any>();

  @Input() dropDownValue = new UntypedFormControl('');;

  @Output() getConfigProductEvent = new EventEmitter<any>();
  @Output() getConfigProductIdNewEvent = new EventEmitter<any>();
  @Output() getConfigProductIdButtonEvent = new EventEmitter<any>();


  getConfigProductId(i,j){

    let obj={
      i:i,
      j:j
    }
    this.getConfigProductEvent.emit(obj);
  }
  
  getConfigProductIdNew(i,j,k,l){
    let obj={
      i:i,
      j:j,
      k:k,
      l:l
    }
    this.getConfigProductIdNewEvent.emit(obj);
  }

  getConfigProductIdButton(i,j){
    let obj={
      i:i,
      j:j,
    }
    this.getConfigProductIdButtonEvent.emit(obj);
  }
}
